import React, { useState } from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { PaymentInfoStyled } from "./styled";
import {
  RENDER_BOOKING_EVENT_STATUS,
  RENDER_PAYMENT_METHOD,
  RENDER_BOOKING_STEP,
  IS_ALL_PAYMENTS_ACKNOWLEDGED,
} from "utils/functions/musicHall";
import momentTZ from "moment-timezone";
import { portalService } from "apiServices";
import { IMG_PATH } from "utils/constants/imgPath";
import { toast } from "react-toastify";
import { RenderCommaMoney } from "utils/functions/FormatMoney";
import { Buttons, Displays, Forms, Icons, Modals } from "components";

const PaymentInfo = ({
  theme_standard,
  booking_date,
  booking_source,
  event_status,
  _id,
  payments,
  pricing,
  status,
  onSuccess,
}) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });

  const [_isBgLoading, _setIsBgLoading] = useState(false);
  const [_renderModal, _setRenderModal] = useState(false);

  const _handleCloseModal = () => {
    _setRenderModal(false);
  };
  const _handleClickModal = () => {
    _setRenderModal(
      <Forms.MusicHallEventForm
        initialValues={{ ...pricing, event_status: event_status }}
        booking_date={booking_date}
        bookingStatus={status}
        isInternal={booking_source === "2"}
        onBack={_handleCloseModal}
        onSubmit={_handleSubmit}
      />,
    );
  };
  const _handleSubmit = async (values) => {
    _setIsBgLoading(true);
    let params = {
      ...values,
    };
    let res = await portalService.PATCH_ROOM_BOOKING_EVENT_STATUS(_id, params);
    if (res && res.status === 200) {
      _setIsBgLoading(false);
      _handleCloseModal();
      toast.success("Update status successfully");
      onSuccess && onSuccess();
    } else {
      _setIsBgLoading(false);
      toast.error("Update status failed");
    }
  };

  const _handleClickAddPayment = () => {
    _setRenderModal(
      <Forms.MusicHallPaymentForm
        initialValues={{ ...pricing, event_status: event_status }}
        onBack={_handleCloseModal}
        onSubmit={_handleAdminReceiptSubmit}
      />,
    );
  };
  const _handleAdminReceiptSubmit = async (values) => {
    _setIsBgLoading(true);
    let params = {
      ...values,
    };
    if (values.slip_upload && values.slip_upload.length > 0) {
      params.slip_upload = values.slip_upload[0].path;
    }
    let res = await portalService.PATCH_ROOM_BOOKING_ADMIN_RECEIPT(_id, params);
    if (res && res.status === 200) {
      _setIsBgLoading(false);
      _handleCloseModal();
      toast.success("Update status successfully");
      onSuccess && onSuccess();
    } else {
      _setIsBgLoading(false);
      toast.error("Update status failed");
    }
  };

  // ปุ่มสีม่วง + เลข = แอดมินมีงานต้องกดปุ่มนี้ / สีขาวไม่มีเลข = ยังไม่มีอะไรต้องทำ
  // 3.2 = status 4 ยืนยันสลิปครบแล้ว เหลือกรอกยอด (Submit แล้ว API เปลี่ยนเป็น Booking Success ให้เอง)
  // 4 = status 5 ถึงวันจัดงานแล้ว เหลือปิดงาน (ก่อนวันงาน "Waiting for event" ยังไม่มีอะไรต้องทำ)
  const isEventDayReached =
    booking_date &&
    !momentTZ(booking_date)
      .tz("Asia/Bangkok")
      .startOf("day")
      .isAfter(momentTZ().tz("Asia/Bangkok").startOf("day"));
  const actionStepNo =
    status === "4" && IS_ALL_PAYMENTS_ACKNOWLEDGED(payments)
      ? "3.2"
      : status === "5" && isEventDayReached
        ? "4"
        : null;
  const actionStep = RENDER_BOOKING_STEP(actionStepNo === "3.2" ? 3 : 4);

  // สรุปยอด ต้องคิดเหมือนฟอร์ม Event Status และรายได้ที่ลงบัญชีตอนปิดงาน
  // (room_amount = base_amount, additional_amount = additional_services_amount ไม่รวมค่าอุปกรณ์)
  const baseAmount = Number(pricing?.base_amount) || 0;
  const servicesAmount = Number(pricing?.additional_services_amount) || 0;
  const equipmentAmount = Number(pricing?.additional_equipment_amount) || 0;
  const paidAmount = Number(pricing?.advance_booking_paid) || 0;
  // base_amount ไม่ถูกตั้งตอนสร้าง booking = 0 จนกว่าแอดมินจะกรอกในฟอร์ม Event Status
  const isBaseAmountSet = baseAmount > 0;
  const totalServiceAmount = baseAmount + servicesAmount;
  const outstandingAmount = totalServiceAmount - paidAmount;

  return (
    <>
      <Displays.BGLoading visible={_isBgLoading} />
      <PaymentInfoStyled
        className={customClass}
        stepBgColor={actionStep.bgColor}
        stepTxtColor={actionStep.txtColor}
      >
        <div className="paymentinfo_row">
          <div className="paymentinfo_text1">Payment</div>
        </div>
        <div
          className={cx("paymentinfo_status_block", {
            is_action: !!actionStepNo,
          })}
        >
          <div className="paymentinfo_text2">
            {RENDER_BOOKING_EVENT_STATUS(event_status).labelEn}
          </div>
          {event_status !== "3" &&
            event_status !== "4" &&
            event_status !== "5" && (
              <Buttons.BgIconPrefix
                theme_edit_action
                label="Edit/Action"
                icon={
                  <>
                    {actionStepNo ? (
                      <span className="btn_step_no">{actionStepNo}</span>
                    ) : null}
                    <Icons.Edit />
                  </>
                }
                onClick={_handleClickModal}
              />
            )}
        </div>
        <div className="paymentinfo_add_row">
          <Buttons.BgIconPrefix
            theme_edit_action
            label="Add Payment"
            icon={<Icons.Edit color="#1DBE12" />}
            onClick={_handleClickAddPayment}
          />
        </div>
        <div className="paymentinfo_detail">
          {payments &&
            payments.length > 0 &&
            payments
              .filter((f) => f.acknowledged_status === "2")
              .map((e, i) => (
                <div key={i} className="paymentinfo_row_date1">
                  {/* กลุ่มซ้ายกว้างเท่า label + กล่องตัวเลขของแถวด้านล่าง ยอดเงินจะตรงแนว "Added by admin" */}
                  <div className="paymentinfo_row_left">
                    <div className="paymentinfo_date_text1">
                      {momentTZ(e.paid_at)
                        .tz("Asia/Bangkok")
                        .format("DD/MM/YYYY HH:mm")}
                    </div>
                    <div className="paymentinfo_date_text2">
                      {e.payment_status === "2" &&
                        RENDER_PAYMENT_METHOD(e.payment_method).labelTh}
                    </div>
                    <a
                      className="paymentinfo_link"
                      href={IMG_PATH + e.slip_upload}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Link
                    </a>
                  </div>
                  <div className="paymentinfo_date_text3">
                    <span className="paymentinfo_amount">
                      {RenderCommaMoney(e.transfer_amount)}
                    </span>{" "}
                    {e.payment_method === "3" && (
                      <span className="paymentinfo_amount_note">
                        (ยอดโอนจากสลิป เช็คโดยระบบ)
                      </span>
                    )}
                  </div>
                </div>
              ))}

          {/* <div className="paymentinfo_row_date1">
          <div className="paymentinfo_date_text1">27/03/2025 16:15</div>
          <div className="paymentinfo_date_text2">โอนสำเร็จ</div>
          <a className="paymentinfo_link" href="https://www.google.com//">
            Link
          </a>
          <div className="paymentinfo_date_text3">5,000.00</div>
        </div> */}
        </div>

        {/* สรุปยอด ใช้สูตรเดียวกับฟอร์ม Event Status: C = A + B, ยอดคงค้าง = C - D */}
        <div className="paymentinfo_summary">
          <div className="ps_row">
            <div className="ps_label">ค่าห้อง</div>
            <div className="ps_value">
              {isBaseAmountSet ? RenderCommaMoney(baseAmount) : "-"}
            </div>
            {!isBaseAmountSet && (
              <div className="ps_side ps_hint">ยังไม่ได้กรอก</div>
            )}
          </div>
          <div className="ps_row">
            <div className="ps_label">
              ค่าบริการเพิ่มเติม
              {equipmentAmount > 0 && (
                <div className="ps_label_note">
                  ไม่รวมค่าอุปกรณ์ที่เลือกตอนจอง{" "}
                  {RenderCommaMoney(equipmentAmount)} บาท
                </div>
              )}
            </div>
            <div className="ps_value">{RenderCommaMoney(servicesAmount)}</div>
          </div>
          <div className="ps_row ps_total">
            <div className="ps_label">รวมค่าบริการ</div>
            <div className="ps_value">
              {isBaseAmountSet ? RenderCommaMoney(totalServiceAmount) : "-"}
            </div>
          </div>
          <div className="ps_divider" />
          <div className="ps_row ps_paid">
            <div className="ps_label">ยอดรวมชำระเงินจากลูกค้าทุกช่องทาง</div>
            <div className="ps_value">{RenderCommaMoney(paidAmount)}</div>
            <div className="ps_side">
              <div className="paymentinfo_date">
                {pricing.advance_booking_paid_date
                  ? momentTZ(pricing.advance_booking_paid_date)
                      .tz("Asia/Bangkok")
                      .format("DD/MM/YYYY HH:mm")
                  : ""}
              </div>
              <div className="paymentinfo_date2">Added by admin</div>
            </div>
          </div>
          <div className="ps_row ps_outstanding">
            <div className="ps_label">ยอดคงค้าง (ต้องเรียกเก็บจากลูกค้า)</div>
            <div className="ps_value">
              {/* ยังไม่กรอกค่าห้อง คิดยอดคงค้างไม่ได้ (จะติดลบหลอก ๆ) */}
              {isBaseAmountSet ? RenderCommaMoney(outstandingAmount) : "-"}
            </div>
            {isBaseAmountSet && outstandingAmount < 0 && (
              <div className="ps_side ps_hint">ชำระเกิน</div>
            )}
          </div>
        </div>

        <div className="paymentinfo_adminnote">
          <div className="paymentinfo_note_title">Admin Note</div>
          <div className="paymentinfo_note_detail">
            {pricing.additional_services_admin_note}
          </div>
        </div>
      </PaymentInfoStyled>
      <Modals.BodyEmpty
        isShowModal={!!_renderModal}
        onCloseModal={_handleCloseModal}
      >
        {_renderModal}
      </Modals.BodyEmpty>
    </>
  );
};

PaymentInfo.propTypes = {};

export default PaymentInfo;
